<script>
	import { onMount } from "svelte";
	import { push, pop, replace } from "svelte-spa-router";
	import { shuffle, mean, min } from "lodash";
	import Icon from "svelte-awesome";
    import { faBars } from "@fortawesome/free-solid-svg-icons";
	import Break from "../../components/break/Break.svelte";
	import { onBreak } from "../../components/break/stores";
	import GetRequestApiInstance from "../../services/ServiceRequestApi";
	import GetReactionTimeInstance from "../../services/ServiceReactionTime";
	// instances services
	const requestApiInstance = GetRequestApiInstance();
	const reactionTimeInstance = GetReactionTimeInstance();
	// constantes
	const GAME_NAME = "same-color";
	const START_MESSAGE = "Cliquez ici pour commencer !";
	const INITIAL_TIME = 30;
	const ARRAY_COLORS = ["beige", "sameColor-yellow", "sameColor-red", "sameColor-blue", "sameColor-green"]; // beige | yellow | red | blue | green
	// paramètres
	export let params = {};
	let difficulty = params.difficulty;
	// variables
	let message = START_MESSAGE;
	let numActualColor = 0;
	let arrayButtonsKey = [1, 2, 3, 4];
	let bestScore = 0;
	// result
	let result = {
		game_name: GAME_NAME,
		difficulty: difficulty,
		score: 0,
		average_time_reaction: 0,
		best_time_reaction: 0
	};
	let isStart = false;
	let timer = INITIAL_TIME;
	let timeIsStopped = true;
	let arrayReactionTime = [];
	let interval;

	onMount(() => {
		onBreak.set(false);
		bestScore = getScoreMax();
	});
	
	async function getScoreMax() {
		let responseScoreMax = await requestApiInstance.get(`bestResult/${GAME_NAME}/${difficulty}`);
		return responseScoreMax[0].score;
	}

	function initEnd() {
		isStart = false;
		timeIsStopped = true;
		clearInterval(interval);
		result.score = 0;
		numActualColor = 0;
		setMessage(START_MESSAGE);
		timer = INITIAL_TIME;
	}

	function initStart() {
		isStart = true;
		timeIsStopped = false;
		setMessage("");
	}
	
	function handleStart() {
		if (!isStart) {
			initStart();
			reactionTimeInstance.startTimeReaction();
			startTimer();
			randomColor();
		}
	}
	
	function stop() {
		arrayReactionTime = reactionTimeInstance.getArrayReactionTime();
		reactionTimeInstance.resetArrayReactionTime();

		if(arrayReactionTime.length > 0) {
			result.average_time_reaction = Math.round(mean(arrayReactionTime));
			result.best_time_reaction = min(arrayReactionTime);
		}
		
		timeIsStopped = true;
		push("/ranking/" + GAME_NAME + "/" + difficulty + "/" + btoa("game_name=" + result.game_name + "&difficulty=" + result.difficulty + "&score=" + result.score + "&average_time_reaction=" + result.average_time_reaction + "&best_time_reaction=" + result.best_time_reaction ));
	}

	function startTimer() {
		if(!$onBreak && isStart) {
			interval = setInterval(function () {
				if (timer > 0 && !timeIsStopped) {
					timer--;
				} else if(timer == 0) {
					clearInterval(interval);
					stop();
				}
			}, 1000);
		}
	}

	function handleClicBtn() {
		if (isStart) verifyColor(this);
	}

	function randomColor() {
		if (difficulty == "hard") {
			let randomArrayButtonsKey = shuffle(arrayButtonsKey);
			while (arrayButtonsKey == randomArrayButtonsKey) {
				randomArrayButtonsKey = shuffle(arrayButtonsKey);
			}
			arrayButtonsKey = randomArrayButtonsKey;
		}
		let randomNum = Math.floor(Math.random() * 4) + 1;
		while (randomNum == numActualColor) {
			randomNum = Math.floor(Math.random() * 4) + 1;
		}
		numActualColor = randomNum;
	}

	function verifyColor(elthis) {
		if (numActualColor == elthis.getAttribute(["data-color"])) {
			result.score++;
			if (result.score > bestScore) {
				bestScore = result.score;
			}
			timeToReact();
			randomColor();
		} else {
			stop();
		}
	}

	function timeToReact() {
		reactionTimeInstance.saveTimeToReact();
	}

	function setMessage(value) {
		message = value;
	}

	function handleBreakButton() {
		onBreak.set(true);
		timeIsStopped = true;
		initEnd();
	}
</script>

<style>
	.message {
		@apply font-thin text-3xl text-center select-none;
	}
	.button-color-response {
		@apply outline-none h-1/5 border-none rounded mx-3 my-4;
		width: calc(70% / 2);
	}
</style>

<div class="container-global">
	{#if $onBreak}
		<Break gameName={GAME_NAME} difficulty={difficulty} />
	{/if}
	<div class="h-1/5">
		<div class="header">
			<div class="text-right pt-4 m-auto w-5/6">
				<span class="cursor-pointer" on:click={handleBreakButton}>
					<Icon data={faBars} scale="1.4" />
				</span>
			</div>
			<div class="top-header pb-2">
				<span class="font-semibold text-3xl {timer <= 5 ? 'text-red-500' : ''}">
					{timer}s
				</span>
			</div>
			<div class="middle-header px-4 text-center">
				<div>
					<span class="text-2xl">
						Score : {result.score} | Meilleur score : {#await bestScore}-{:then result}{result}{/await}
					</span>
				</div>
			</div>
		</div>
	</div>
	<div class="h-4/5">
		<div
			on:click={handleStart}
			class="w-full relative flex justify-center items-center h-2/5 bg-{ARRAY_COLORS[numActualColor]}">
			<h2 class="message">{message}</h2>
		</div>
		<div class="w-full h-3/5 bg-beige-light flex justify-center items-center flex-wrap">
			{#each arrayButtonsKey as key}
				<div
					on:mousedown={handleClicBtn}
					data-color={key}
					class="button-color-response bg-{ARRAY_COLORS[key]}">
				</div>
			{/each}
		</div>
	</div>
</div>